import React, { useContext, useState, useEffect } from 'react';
import { ServerContext } from '../../App';
import Button from '../Button/Button';

import './Popup.scss';
import { TError } from '../../services/server/types';

type TInnerButton = {
    isHover?: boolean;
    text: string;
    onClick: () => void;
}

export type TPopupData = {
    className?: string;
    title?: string;
    text?: string;
    closeHovered?: boolean;
    buttons?: TInnerButton[];
};

const Popup: React.FC = () => {
    const server = useContext(ServerContext);
    const [data, setData] = useState<TPopupData | null>(null);
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const showErrorHandler = (error: TError) => {
            const { code, text } = error;
            setData({
                title: `#${code}`,
                text,
            });
            setIsVisible(true);
            
            setTimeout(() => {
                setIsVisible(false);
                setTimeout(() => setData(null), 300);
            }, 3000);
        }
    
        server.showError(showErrorHandler);
    });

    if (!data) return (<></>);

    const { title, text, buttons = [] } = data;

    const handleClose = () => {
        setIsVisible(false);
        setTimeout(() => setData(null), 300);
    };

    return (
        <div className={`popup ${isVisible ? 'popup--visible' : 'popup--hidden'}`}>
            <div className="popup-container">
                <div className="popup-content">
                    <div className="popup-icon-wrapper">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            strokeWidth="1.5"
                            stroke="currentColor"
                            className="popup-icon"
                        >
                            <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                d="M12 9v3.75m9-.75a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9 3.75h.008v.008H12v-.008Z"
                            />
                        </svg>
                    </div>
                    <div className="popup-text-content">
                        <p className="popup-title-text">{title || 'Ошибка'}</p>
                        <p className="popup-description">{text || 'Произошла ошибка'}</p>
                    </div>
                    <button
                        className="popup-close-button"
                        onClick={handleClose}
                        aria-label="Закрыть"
                    >
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            strokeWidth="1.5"
                            stroke="currentColor"
                            className="popup-close-icon"
                        >
                            <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                d="M6 18 18 6M6 6l12 12"
                            />
                        </svg>
                    </button>
                </div>
                {buttons.length > 0 && (
                    <div className="popup-buttons">
                        {buttons.map((data, index) => {
                            const { text, onClick, isHover } = data;
                            return (
                                <Button
                                    variant='main'
                                    key={index}
                                    text={text}
                                    onClick={onClick}
                                    isHover={isHover}
                                />
                            );
                        })}
                    </div>
                )}
            </div>
        </div>
    );
}

export default Popup;